const strings = {
  APARTMENT_NUMBER: 'Lägenhetsnummer',
  EMAIL: 'Email',
  PASSWORD: 'Lösenord',
  JANITOR: 'Vaktmästare',
  ADMIN: 'Administratör',
  CANCEL: 'Avbryt',
  DONE: 'Klar'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/common/UserModal/strings.js